module.exports = __webpack_public_path__ + "static/media/polls.e35b0f72.svg";